<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      inboxName: '',
    };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
  },
  validations: {
    inboxName: { required },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const wuzapiChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.inboxName?.trim(),
            channel: {
              type: 'whatsapp',
              provider: 'wuzapi',
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: wuzapiChannel.id,
          },
        });
      } catch (error) {
        useAlert(
          error.message ||
            'Não foi possível criar a caixa de entrada WuConnect. Tente novamente.'
        );
      }
    },
  },
};
</script>

<template>
  <form class="flex flex-wrap flex-col mx-0" @submit.prevent="createChannel()">
    <div class="mb-4 text-body-main text-n-slate-11">
      O WuConnect conecta seu número de WhatsApp. Ao criar a caixa de entrada,
      uma nova instância é provisionada automaticamente no WuConnect; em
      seguida, você poderá parear o número pelo QR code.
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.inboxName.$error }">
        Nome da caixa de entrada
        <input
          v-model="inboxName"
          type="text"
          placeholder="Ex.: Atendimento WhatsApp"
          @blur="v$.inboxName.$touch"
        />
        <span v-if="v$.inboxName.$error" class="message">
          Informe o nome da caixa de entrada
        </span>
      </label>
    </div>

    <div class="w-full">
      <NextButton
        type="submit"
        label="Criar caixa de entrada"
        :is-loading="uiFlags.isCreating"
      />
    </div>
  </form>
</template>
